<template>
  <div class="LoginFormBox">
    <Form ref="form" class="form-box" :model="form" :rules="ruleInline">
      <FormItem prop="phone">
        <Input
          type="text"
          ref="phoneInput"
          @input="deleteBox('phone')"
          size="large"
          v-model="form.phone"
          :placeholder="$t('login.phone')"
        >
          <div slot="prepend" @click="openLang" class="item_select">
            <div>+{{ form.area }}</div>
            <van-icon name="arrow-down" />
          </div>
        </Input>
      </FormItem>
      <FormItem prop="password">
        <Input
          ref="passwordInput"
          @input="deleteBox('password')"
          type="password"
          password
          size="large"
          v-model="form.password"
          :placeholder="$t('login.password')"
        />
      </FormItem>
      <FormItem prop="isAgree" class="FormItemCheck">
        <Checkbox v-model="form.isAgree"
          ><span class="isAgreeTxt">{{ $t("login.remember") }}</span></Checkbox
        >
        <!-- <span>{{ $t('login.forget') }}</span> -->
      </FormItem>
      <FormItem class="signBtn">
        <van-button
          class="signbtn-con"
          :loading="loading"
          :loading-text="$t('loading.loadingLogin')"
          @click.prevent="handleSubmit('form')"
          type="danger"
          >{{ $t("login.loginBtn") }}</van-button
        >
      </FormItem>
      <p class="goLoginBox">
        {{ $t("login.noAccount")
        }}<span class="goLogin" @click="goSign()">
          {{ $t("login.goRegister") }}</span
        >
      </p>
    </Form>
  </div>
</template>
<script>
const noop = () => { }; // 定义一个空函数
noop(); // 调用它不做任何事情
import { Login } from "@/api";
export default {
  props: ["value"],
  data() {
    return {
      loading: false,
      form: {
        password: "",
        phone: "",
        area: "1",
      },
      ruleInline: {
        phone: [
          {
            required: true,
            message: this.$t("sign.rule.phone[0]"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("sign.rule.password[0]"),
            trigger: "blur",
          },
          {
            min: 6,
            message: this.$t("sign.rule.password[1]"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {},
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.form.area = newVal;
      },
      immediate: true, //深度监听
    },
  },
  methods: {
    deleteBox(field) {
      if (this.form[field] == undefined) {
        return;
      }
      if (field == "phone") {
        if (/[^\d]/.test(this.form[field])) {
          let str = this.form[field].replace(/[^\d]/g, "");
          this.$nextTick(() => {
            const inputElement = this.$refs[field + "Input"];
            inputElement.$emit("input");
            this.form[field] = str;
          });
        }
      } else if (this.form[field].includes(" ")) {
        let str = this.form[field].replace(/\s+/g, "");
        this.$nextTick(() => {
          const inputElement = this.$refs[field + "Input"];
          inputElement.$emit("input");
          this.form[field] = str;
        });
      }
    },
    openLang() {
      this.$router.push({
        path: "/language",
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = {
            phone: this.form.area + this.form.phone,
            password: this.form.password,
          };
          this.login(data);
        }
      });
    },
    login(val) {
      this.loading = true;
      Login(val).then((res) => {
        if (res.code == 1) {
          this.$store.commit("setToken", res.data.token);
          this.$store.dispatch("getInfo");
          this.$Toast.success(res.info);
          this.$router.push(this.$route.query.redirect || "/home");
          this.$store.commit('changeTan', true);
        }
        this.loading = false;
      });
    },
    goSign() {
      this.$emit("TabChangeBox", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.LoginFormBox {
  width: 100%;
  background-color: #fff;
  margin-top: 50px;
  display: flex;
  padding: 30px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  border-radius: 16px;
  color: #000;

  ::v-deep(.ivu-input) {
    padding: 0 18px;
    height: 46px;
  }

  .form-box {
    width: 100%;

    .item_select {
      width: 52px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    ::v-deep(.ivu-input-group-append) {
      background-color: #fff;
    }

    ::v-deep(.ivu-input-group-prepend) {
      background-color: #fff;
    }

    .FormItemCheck {
      span {
        float: right;
        font-size: 12px;
        color: #7e7e88;
      }

      .isAgreeTxt {
        color: #717180;
        font-size: 14px;
      }

      ::v-deep(.ivu-checkbox-inner) {
        margin-right: 5px;
      }
    }

    .signBtn {
      .signbtn-con {
        height: 46px;
        font-size: 20px;
        width: 100%;
        border-radius: 10px;
        background: #ee264d;
        box-shadow: 0px 6px 10px 0px rgba(128, 128, 128, 0.5);
      }
    }

    .goLoginBox {
      text-align: center;
      color: #717180;
      font-size: 12px;

      .goLogin {
        color: #ee264d;
        font-weight: bold;
        margin: 0 0 0 6px;
      }
    }
  }
}
.ivu-form-item {
  margin-bottom: 20px;
}
::v-deep(.ivu-input-suffix) i {
  line-height: 46px;
}
</style>